// extracted by mini-css-extract-plugin
export default {"tabWrapper":"TabBar_tabWrapper__hiKJh"};